import { Box, Flex, Select, Text } from "@mantine/core";
import { Dispatch, SetStateAction } from "react";

interface IPropsHeaderSelect {
  parseFile: (file: File | null, headerRow: number) => void;
  file: File | null;
  headerIndex: string | null;
  setHeaderIndex: Dispatch<SetStateAction<string | null>>;
}

export default function HeaderIndexSection(props: IPropsHeaderSelect) {
  const { parseFile, file, headerIndex, setHeaderIndex } = props;
  return (
    <Box mt="md">
      <Box>
        <Text fw={500}>헤더 행 번호</Text>
      </Box>
      <Flex>
        <Select
          description="컬럼 제목이 있는 행 번호를 선택하세요."
          placeholder="헤더 행 번호를 선택해주세요."
          data={Array.from({ length: 20 }, (_, i) => ({
            label: String(i + 1),
            value: String(i + 1),
          }))}
          value={headerIndex}
          onChange={(value) => {
            if (!value) return;
            setHeaderIndex(value);
            parseFile(file, Number(value));
          }}
          w={220}
        />
      </Flex>
    </Box>
  );
}
